<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">{{ $t('rulesForm.detailConsequenceTitle') }}</h2>
            <p class="text-muted small mb-0">{{ consequence.name || ($currentLocale === 'id' ? 'Aturan Pelanggaran SOP' : 'SOP Violation Rule') }}</p>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2 mt-2 mt-md-0">
          <router-link :to="{ name: 'EditConsequence', params: { id: id } }" class="btn btn-primary px-3 py-2 mr-2 font-weight-bold">
            <i class="mdi mdi-lead-pencil mr-1"></i> {{ $t('common.edit') }}
          </router-link>
          <button type="button" class="btn btn-outline-danger px-3 py-2" @click="confirmDelete" :disabled="loading">
            <i class="mdi mdi-delete-outline mr-1"></i> {{ $t('common.delete') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Main Card -->
    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body">
          <div class="row">
            <!-- Left Column: Violation Info -->
            <div class="col-md-7 mb-4">
              <span class="badge badge-outline-danger px-3 py-2 font-weight-bold text-uppercase mb-3 d-inline-block">
                <i class="mdi mdi-alert-circle-outline mr-1"></i> {{ $t('rulesForm.penaltyType') }}
              </span>

              <h3 class="text-white font-weight-bold mb-3">{{ consequence.name }}</h3>

              <div class="p-3 bg-dark rounded border border-secondary mb-4">
                <label class="text-muted small text-uppercase font-weight-bold d-block mb-2">{{ $t('common.description') }}</label>
                <p class="text-white mb-0" style="white-space: pre-wrap;">{{ consequence.description || ($currentLocale === 'id' ? 'Tidak ada deskripsi rinci untuk pelanggaran SOP ini.' : 'No detailed description provided for this SOP violation.') }}</p>
              </div>

              <div class="text-muted small">
                <i class="mdi mdi-clock-outline mr-1"></i> {{ $t('common.date') }}: {{ formatDate(consequence.created_at) }}
              </div>
            </div>

            <!-- Right Column: Penalty Deduction Card -->
            <div class="col-md-5 mb-4">
              <div class="p-4 bg-dark rounded border border-secondary text-center h-100 d-flex flex-column justify-content-center">
                <label class="text-muted small text-uppercase font-weight-bold d-block mb-2">{{ $t('quests.pointsDeduction') }}</label>
                <div v-if="consequence.gold" class="d-flex align-items-center justify-content-center">
                  <i class="mdi mdi-minus-circle text-danger display-4 mr-2"></i>
                  <span class="text-danger display-4 font-weight-bold">-{{ consequence.gold }}</span>
                  <span class="text-danger font-weight-bold ml-2">{{ $t('rulesForm.goldCoins') }}</span>
                </div>
                <div v-else class="text-warning font-weight-bold py-2">
                  <i class="mdi mdi-alert-octagon-outline mr-1"></i> {{ consequence.non_gold || $t('rulesForm.penaltyNonGold') }}
                </div>
                <small class="text-muted mt-3">
                  {{ $currentLocale === 'id' ? 'Poin ini akan otomatis dipotong dari saldo player setelah laporan pelanggaran disetujui Game Maker atau Game Owner.' : 'These points will be automatically deducted from the player balance once the violation report is verified.' }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailConsequence, deleteConsequence } from "../../services/consequenceService";
import Swal from 'sweetalert2';
import moment from 'moment';

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => ({
    consequence: {},
    loading: false,
  }),
  methods: {
    back() {
      this.$router.go(-1);
    },
    async fetchConsequence() {
      try {
        const response = await getDetailConsequence(this.id);
        this.consequence = response.data || {};
      } catch (err) {
        console.error('Error fetching consequence:', err);
      }
    },
    confirmDelete() {
      Swal.fire({
        title: this.$t('quests.confirmDelete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        cancelButtonColor: '#6b7280',
        confirmButtonText: this.$t('common.delete'),
        cancelButtonText: this.$t('common.cancel'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.loading = true;
            await deleteConsequence(this.id);
            Swal.fire({
              icon: 'success',
              title: this.$t('common.success'),
              text: this.$t('rulesForm.deletedSuccess'),
              confirmButtonColor: '#3b82f6'
            });
            this.$router.push('/rules/consequences');
          } catch (err) {
            Swal.fire({
              icon: 'error',
              title: this.$t('common.error') || (this.$currentLocale === 'id' ? 'Terjadi Kesalahan' : 'Error'),
              text: this.$currentLocale === 'id' ? 'Gagal menghapus aturan sanksi SOP.' : 'Failed to delete consequence rule.',
            });
          } finally {
            this.loading = false;
          }
        }
      });
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('DD MMM YYYY, HH:mm');
    }
  },
  mounted() {
    this.fetchConsequence();
  }
};
</script>
